/**
 * Handler to clear discounts for guest users across the entire site.
 */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Check if meowcart config is available
    if (typeof meowcart === 'undefined') return;

    // Safety check for Shopify routes
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        // Condition: If there's a discount applied but no user is logged in
        const hasDiscount = cart.total_discount > 0 || 
                            (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);
        
        if (hasDiscount) {
          console.log('[Loyalty] Guest detected with active discounts. Clearing...');
          
          let url = meowcart.api_url + meowcart.endpoints.shopify.updateDiscount;
          if (url.includes("/the1/shopify")) {
            url = url.replace("/the1/shopify", "/shopify");
          }

          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              cartId: cart.token,
              discountCodes: [""]
            })
          }).then(response => {
            if (response.ok) {
              console.log('[Loyalty] Discounts cleared for guest.');
              if (window.location.pathname.includes('/cart')) {
                // window.location.reload();
              }
            }
          }).catch(err => console.error('[Loyalty] Error clearing guest discounts:', err));
        }
      })
      .catch(err => console.error('[Loyalty] Error fetching cart for guest cleanup:', err));
  });
})();
